(function () {
  'use strict';

  var VERSION = '2026-06-22.1-legacy-tabs-safe-conversion';
  var namespace = window.C2BProductTabsBridge = window.C2BProductTabsBridge || {};

  if (namespace.version === VERSION && typeof namespace.boot === 'function') {
    namespace.boot(document);
    return;
  }

  if (typeof namespace.stop === 'function') {
    namespace.stop();
  }

  var DESCRIPTION_SECTION_SELECTOR = '[data-c2b-product-description-section]';
  var DESCRIPTION_CONTENT_SELECTOR = '.c2b-product-full-description';
  var LEGACY_STATION_SELECTOR = '.station-tabs';
  var LEGACY_STATION_TITLE_SELECTOR = 'h2.station-tabs-tabtitle';
  var RAW_HEADING_SELECTOR = 'h2, h3';
  var INIT_ATTRIBUTE = 'data-c2b-legacy-tabs-initialized';
  var STATUS_ATTRIBUTE = 'data-c2b-legacy-tabs-status';
  var GENERATED_SELECTOR = '[data-c2b-legacy-tabs-generated]';
  var NATIVE_REVIEWS_SELECTOR = '.shopify-app-block[id*="judge_me_reviews_review_widget"], #judgeme_product_reviews, .jdgm-widget.jdgm-review-widget';
  var NATIVE_REVIEWS_MOVED_ATTRIBUTE = 'data-c2b-native-reviews-moved';
  var NATIVE_REVIEWS_TAB_ATTRIBUTE = 'data-c2b-native-reviews-tab';
  var NATIVE_REVIEWS_EMPTY_SECTION_CLASS = 'c2b-native-reviews-empty-section';
  var DEFAULT_REVIEWS_TITLE = 'Recenzii';
  var DEFAULT_INTRO_TITLE = 'Descriere';
  var DEFAULT_SKIPPED_TITLES = 'Recenzii';
  var MAX_RETRIES = 80;
  var RETRY_DELAY = 150;
  var OBSERVER_TIMEOUT = 45000;

  var observer = null;
  var observerTarget = null;
  var observerTimer = null;
  var observerRaf = null;
  var retryTimers = [];
  var generatedIdCounter = 0;

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function slugify(value) {
    var normalized = normalizeText(value).toLowerCase();

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function setStatus(section, status) {
    if (section) {
      section.setAttribute(STATUS_ATTRIBUTE, status);
    }
  }

  function restoreDescriptionSection(section) {
    if (!section) {
      return;
    }

    section.classList.remove('is-hidden-by-c2b-legacy-tabs');
    section.removeAttribute('aria-hidden');
  }

  function getDatasetValue(element, name, fallback) {
    if (!element || !element.dataset) {
      return fallback;
    }

    return element.dataset[name] || fallback;
  }

  function splitSkippedTitles(value) {
    return normalizeText(value)
      .split(',')
      .map(function (item) {
        return normalizeText(item).toLowerCase();
      })
      .filter(Boolean);
  }

  function shouldSkipTitle(title, skippedTitles) {
    return skippedTitles.indexOf(normalizeText(title).toLowerCase()) !== -1;
  }

  function htmlHasVisibleContent(html) {
    var wrapper = document.createElement('div');

    wrapper.innerHTML = html || '';

    return normalizeText(wrapper.textContent || '') !== '' || wrapper.querySelector('img, video, iframe, table, ul, ol, svg') !== null;
  }

  function cloneNodesToHtml(nodes) {
    var wrapper = document.createElement('div');

    nodes.forEach(function (node) {
      wrapper.appendChild(node.cloneNode(true));
    });

    return wrapper.innerHTML;
  }

  function pushNodeTab(tabs, tab) {
    var html;

    if (!tab || !tab.nodes || tab.nodes.length === 0) {
      return;
    }

    html = cloneNodesToHtml(tab.nodes);

    if (!htmlHasVisibleContent(html)) {
      return;
    }

    tabs.push({
      title: tab.title,
      html: html
    });
  }

  function safeElementMatches(element, selector) {
    try {
      return Boolean(element && element.matches && element.matches(selector));
    } catch (error) {
      return false;
    }
  }

  function safeElementContainsSelector(element, selector) {
    try {
      return Boolean(element && element.querySelector && element.querySelector(selector));
    } catch (error) {
      return false;
    }
  }

  function getStationRoot(source) {
    if (!source) {
      return null;
    }

    if (safeElementMatches(source, LEGACY_STATION_SELECTOR)) {
      return source;
    }

    return source.querySelector(LEGACY_STATION_SELECTOR);
  }

  function findStationPanelForTitle(titleElement, stationRoot) {
    var tab = titleElement.querySelector('.station-tabs-tab[aria-controls]');
    var panelId;
    var panel;
    var panels;
    var index;

    if (!tab) {
      return null;
    }

    panelId = tab.getAttribute('aria-controls');

    if (!panelId) {
      return null;
    }

    panel = document.getElementById(panelId);

    if (panel && (!stationRoot || stationRoot.contains(panel))) {
      return panel;
    }

    if (!stationRoot) {
      return panel;
    }

    panels = Array.prototype.slice.call(stationRoot.querySelectorAll('.station-tabs-tabpanel'));

    for (index = 0; index < panels.length; index += 1) {
      if (panels[index].id === panelId) {
        return panels[index];
      }
    }

    return panel || null;
  }

  function collectFromStationTabs(source, skippedTitles) {
    var stationRoot = getStationRoot(source);
    var titles;
    var tabs = [];

    if (!stationRoot) {
      return tabs;
    }

    titles = Array.prototype.slice.call(stationRoot.querySelectorAll(LEGACY_STATION_TITLE_SELECTOR));

    titles.forEach(function (titleElement) {
      var title = normalizeText(titleElement.textContent || '');
      var panel = findStationPanelForTitle(titleElement, stationRoot);
      var contentElement;
      var html;

      if (!title || shouldSkipTitle(title, skippedTitles) || !panel) {
        return;
      }

      if (panel.getAttribute('data-type') === 'relocate' || panel.querySelector('[data-tabs-relocate]')) {
        return;
      }

      contentElement = panel.querySelector('.station-tabs-tabcontent') || panel;
      html = contentElement.innerHTML;

      if (!htmlHasVisibleContent(html)) {
        return;
      }

      tabs.push({
        title: title,
        html: html
      });
    });

    return tabs;
  }

  function hasDirectHeading(element) {
    return Array.prototype.slice.call(element.children || []).some(function (child) {
      return safeElementMatches(child, RAW_HEADING_SELECTOR);
    });
  }

  function getRawHeadingContainer(source) {
    var onlyChild;

    if (!source) {
      return null;
    }

    if (hasDirectHeading(source)) {
      return source;
    }

    if (source.children && source.children.length === 1) {
      onlyChild = source.children[0];

      if (hasDirectHeading(onlyChild)) {
        return onlyChild;
      }
    }

    return null;
  }

  function collectFromRawHeadings(source, skippedTitles, introTitle) {
    var headingContainer = getRawHeadingContainer(source);
    var children;
    var tabs = [];
    var currentTab = null;
    var introNodes = [];
    var introHtml;
    var skippingCurrentHeadingSection = false;

    if (!headingContainer) {
      return tabs;
    }

    children = Array.prototype.slice.call(headingContainer.children || []);

    children.forEach(function (child) {
      var isHeading = safeElementMatches(child, RAW_HEADING_SELECTOR);
      var title;

      if (isHeading) {
        title = normalizeText(child.textContent || '');
        pushNodeTab(tabs, currentTab);
        currentTab = null;
        skippingCurrentHeadingSection = false;

        if (!title || shouldSkipTitle(title, skippedTitles)) {
          skippingCurrentHeadingSection = true;
          return;
        }

        currentTab = {
          title: title,
          nodes: []
        };

        return;
      }

      if (currentTab) {
        currentTab.nodes.push(child);
        return;
      }

      if (skippingCurrentHeadingSection) {
        return;
      }

      introNodes.push(child);
    });

    pushNodeTab(tabs, currentTab);

    if (introNodes.length > 0) {
      introHtml = cloneNodesToHtml(introNodes);

      if (htmlHasVisibleContent(introHtml)) {
        tabs.unshift({
          title: introTitle || DEFAULT_INTRO_TITLE,
          html: introHtml
        });
      }
    }

    return tabs;
  }


  function isInsideGeneratedTabs(element) {
    return Boolean(element && element.closest && element.closest(GENERATED_SELECTOR));
  }

  function getNativeReviewsRoot(element) {
    if (!element || !element.closest) {
      return element || null;
    }

    return element.closest('.shopify-app-block') || element.closest('#judgeme_product_reviews') || element;
  }

  function getNativeReviewsSourceCandidates() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(NATIVE_REVIEWS_SELECTOR));
    var candidates = [];

    nodes.forEach(function (node) {
      var source = getNativeReviewsRoot(node);

      if (!source || isInsideGeneratedTabs(source) || source.getAttribute(NATIVE_REVIEWS_MOVED_ATTRIBUTE) === 'true') {
        return;
      }

      if (candidates.indexOf(source) === -1) {
        candidates.push(source);
      }
    });

    return candidates;
  }

  function hasMeaningfulNativeReviewsContent(source) {
    var clone;
    var text;

    if (!source) {
      return false;
    }

    if (source.querySelector('.jdgm-rev-widg, .jdgm-widget-actions-wrapper, .jdgm-write-rev-link, .jdgm-rev, .jdgm-histogram, .jdgm-row-stars, iframe, form, button')) {
      return true;
    }

    clone = source.cloneNode(true);
    Array.prototype.slice.call(clone.querySelectorAll('script, style, [style*="clear"]')).forEach(function (node) {
      node.remove();
    });

    text = normalizeText(clone.textContent || '');

    return text.length > 12;
  }

  function findNativeReviewsSource() {
    var candidates = getNativeReviewsSourceCandidates();
    var index;

    for (index = 0; index < candidates.length; index += 1) {
      if (hasMeaningfulNativeReviewsContent(candidates[index])) {
        return candidates[index];
      }
    }

    return null;
  }

  function nativeReviewsSourceMayBePending() {
    return getNativeReviewsSourceCandidates().length > 0;
  }

  function titleExists(tabs, title) {
    var normalizedTitle = normalizeText(title).toLowerCase();

    return tabs.some(function (tab) {
      return normalizeText(tab.title).toLowerCase() === normalizedTitle;
    });
  }

  function findGeneratedTabsRootForSection(section) {
    var previous = section ? section.previousElementSibling : null;

    if (!previous || !safeElementMatches(previous, GENERATED_SELECTOR)) {
      return null;
    }

    return previous.querySelector('.c2b-product-tabs');
  }

  function generatedRootHasDescriptionTabs(tabsRoot, skippedTitles) {
    var buttons;

    if (!tabsRoot) {
      return false;
    }

    buttons = Array.prototype.slice.call(tabsRoot.querySelectorAll('.c2b-product-tabs__tab[role="tab"]'));

    return buttons.some(function (button) {
      var title = normalizeText(button.textContent || '');

      return title && !shouldSkipTitle(title, skippedTitles);
    });
  }

  function markOldNativeReviewsSection(source) {
    var oldSection;

    if (!source || !source.closest) {
      return;
    }

    oldSection = source.closest('.shopify-section');

    if (oldSection && oldSection.children.length === 0) {
      oldSection.classList.add(NATIVE_REVIEWS_EMPTY_SECTION_CLASS);
    }
  }

  function appendNativeReviewsTab(tabsRoot, source) {
    var tabList;
    var panels;
    var accordion;
    var index;
    var generatedId;
    var tabId;
    var panelId;
    var button;
    var panel;
    var details;
    var summary;
    var summaryText;
    var summaryIcon;
    var detailsContent;

    if (!tabsRoot || !source || tabsRoot.querySelector('[' + NATIVE_REVIEWS_TAB_ATTRIBUTE + '="true"]')) {
      return false;
    }

    tabList = tabsRoot.querySelector('.c2b-product-tabs__tablist');
    panels = tabsRoot.querySelector('.c2b-product-tabs__panels');
    accordion = tabsRoot.querySelector('.c2b-product-tabs__accordion');

    if (!tabList || !panels || !accordion) {
      return false;
    }

    index = tabsRoot.querySelectorAll('.c2b-product-tabs__tab[role="tab"]').length;
    generatedId = 'c2b-native-reviews-tabs-' + (generatedIdCounter += 1);
    tabId = generatedId + '-tab-recenzii';
    panelId = generatedId + '-panel-recenzii';

    button = document.createElement('button');
    button.type = 'button';
    button.className = 'c2b-product-tabs__tab c2b-product-tabs__tab--reviews';
    button.id = tabId;
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('aria-selected', 'false');
    button.setAttribute(NATIVE_REVIEWS_TAB_ATTRIBUTE, 'true');
    button.tabIndex = -1;
    button.textContent = DEFAULT_REVIEWS_TITLE;

    panel = document.createElement('div');
    panel.className = 'c2b-product-tabs__panel c2b-product-tabs__panel--reviews rte';
    panel.id = panelId;
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', tabId);
    panel.setAttribute(NATIVE_REVIEWS_TAB_ATTRIBUTE, 'true');
    panel.hidden = true;

    panel.appendChild(source);
    source.setAttribute(NATIVE_REVIEWS_MOVED_ATTRIBUTE, 'true');
    markOldNativeReviewsSection(source);

    details = document.createElement('details');
    details.className = 'c2b-product-tabs__details c2b-product-tabs__details--reviews';
    details.setAttribute(NATIVE_REVIEWS_TAB_ATTRIBUTE, 'true');

    summary = document.createElement('summary');
    summary.className = 'c2b-product-tabs__summary';
    summaryText = document.createElement('span');
    summaryText.textContent = DEFAULT_REVIEWS_TITLE;
    summaryIcon = document.createElement('span');
    summaryIcon.className = 'svg-wrapper';
    summaryIcon.setAttribute('aria-hidden', 'true');
    summaryIcon.innerHTML = '<svg viewBox="0 0 10 6" focusable="false" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    detailsContent = document.createElement('div');
    detailsContent.className = 'c2b-product-tabs__details-content rte';
    detailsContent.innerHTML = '<p>Recenziile sunt afișate în tabul Recenzii.</p>';

    summary.appendChild(summaryText);
    summary.appendChild(summaryIcon);
    details.appendChild(summary);
    details.appendChild(detailsContent);

    tabList.appendChild(button);
    panels.appendChild(panel);
    accordion.appendChild(details);

    return true;
  }

  function attachNativeReviewsTab(section) {
    var tabsRoot = findGeneratedTabsRootForSection(section);
    var source;

    if (!tabsRoot) {
      return nativeReviewsSourceMayBePending() ? 'pending' : 'none';
    }

    if (tabsRoot.querySelector('[' + NATIVE_REVIEWS_TAB_ATTRIBUTE + '="true"]')) {
      return 'attached';
    }

    source = findNativeReviewsSource();

    if (!source) {
      return nativeReviewsSourceMayBePending() ? 'pending' : 'none';
    }

    return appendNativeReviewsTab(tabsRoot, source) ? 'attached' : 'pending';
  }

  function removeExistingGenerated(section) {
    var previous = section ? section.previousElementSibling : null;

    if (previous && safeElementMatches(previous, GENERATED_SELECTOR)) {
      previous.remove();
    }
  }

  function buildTabs(section, tabs, displayMode) {
    var generatedId = 'c2b-legacy-product-tabs-' + (generatedIdCounter += 1);
    var shell = document.createElement('section');
    var shellInner = document.createElement('div');
    var tabsRoot = document.createElement('div');
    var tabList = document.createElement('div');
    var panels = document.createElement('div');
    var accordion = document.createElement('div');

    shell.className = 'c2b-product-tabs-section c2b-product-tabs-section--legacy quick-add-hidden';
    shell.setAttribute('data-c2b-legacy-tabs-generated', 'true');
    shell.setAttribute('data-c2b-legacy-tabs-version', VERSION);

    shellInner.className = 'c2b-product-tabs-shell';
    tabsRoot.className = 'c2b-product-tabs c2b-product-tabs--' + (displayMode || 'desktop_tabs_mobile_accordion');

    tabList.className = 'c2b-product-tabs__tablist';
    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-label', 'Informații produs');

    panels.className = 'c2b-product-tabs__panels';
    accordion.className = 'c2b-product-tabs__accordion';

    tabs.forEach(function (tab, index) {
      var tabSlug = slugify(tab.title) || 'tab';
      var tabId = generatedId + '-tab-' + index + '-' + tabSlug;
      var panelId = generatedId + '-panel-' + index + '-' + tabSlug;
      var button = document.createElement('button');
      var panel = document.createElement('div');
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var summaryText = document.createElement('span');
      var summaryIcon = document.createElement('span');
      var detailsContent = document.createElement('div');

      button.type = 'button';
      button.className = 'c2b-product-tabs__tab';
      button.id = tabId;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panelId);
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      button.tabIndex = index === 0 ? 0 : -1;
      button.textContent = tab.title;

      if (tab.node) {
        button.setAttribute(NATIVE_REVIEWS_TAB_ATTRIBUTE, 'true');
      }

      if (index === 0) {
        button.classList.add('is-active');
      }

      panel.className = 'c2b-product-tabs__panel rte';
      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);

      if (tab.node) {
        panel.setAttribute(NATIVE_REVIEWS_TAB_ATTRIBUTE, 'true');
        panel.appendChild(tab.node);
        tab.node.setAttribute(NATIVE_REVIEWS_MOVED_ATTRIBUTE, 'true');
        markOldNativeReviewsSection(tab.node);
      } else {
        panel.innerHTML = tab.html;
      }

      if (index === 0) {
        panel.classList.add('is-active');
      } else {
        panel.hidden = true;
      }

      details.className = 'c2b-product-tabs__details';

      if (tab.node) {
        details.setAttribute(NATIVE_REVIEWS_TAB_ATTRIBUTE, 'true');
      }

      if (index === 0) {
        details.open = true;
      }

      summary.className = 'c2b-product-tabs__summary';
      summaryText.textContent = tab.title;
      summaryIcon.className = 'svg-wrapper';
      summaryIcon.setAttribute('aria-hidden', 'true');
      summaryIcon.innerHTML = '<svg viewBox="0 0 10 6" focusable="false" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      detailsContent.className = 'c2b-product-tabs__details-content rte';

      if (tab.node) {
        detailsContent.innerHTML = '<p>Recenziile sunt afișate în tabul Recenzii.</p>';
      } else {
        detailsContent.innerHTML = tab.html;
      }

      summary.appendChild(summaryText);
      summary.appendChild(summaryIcon);
      details.appendChild(summary);
      details.appendChild(detailsContent);

      tabList.appendChild(button);
      panels.appendChild(panel);
      accordion.appendChild(details);
    });

    tabList.addEventListener('click', function (event) {
      var selectedButton = event.target.closest('.c2b-product-tabs__tab');

      if (!selectedButton || !tabList.contains(selectedButton)) {
        return;
      }

      activateTab(tabsRoot, selectedButton);
    });

    tabList.addEventListener('keydown', function (event) {
      handleTabKeydown(event, tabsRoot);
    });

    tabsRoot.appendChild(tabList);
    tabsRoot.appendChild(panels);
    tabsRoot.appendChild(accordion);
    shellInner.appendChild(tabsRoot);
    shell.appendChild(shellInner);

    removeExistingGenerated(section);
    section.parentNode.insertBefore(shell, section);

    return shell;
  }

  function activateTab(tabsRoot, selectedButton) {
    var buttons = Array.prototype.slice.call(tabsRoot.querySelectorAll('.c2b-product-tabs__tab[role="tab"]'));
    var panels = Array.prototype.slice.call(tabsRoot.querySelectorAll('.c2b-product-tabs__panel[role="tabpanel"]'));

    buttons.forEach(function (button) {
      var isSelected = button === selectedButton;

      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      button.tabIndex = isSelected ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var isSelected = panel.id === selectedButton.getAttribute('aria-controls');

      panel.classList.toggle('is-active', isSelected);
      panel.hidden = !isSelected;
    });
  }

  function handleTabKeydown(event, tabsRoot) {
    var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    var buttons;
    var currentIndex;
    var nextIndex;

    if (keys.indexOf(event.key) === -1) {
      return;
    }

    buttons = Array.prototype.slice.call(tabsRoot.querySelectorAll('.c2b-product-tabs__tab[role="tab"]'));
    currentIndex = buttons.indexOf(document.activeElement);

    if (currentIndex === -1) {
      return;
    }

    event.preventDefault();

    if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = buttons.length - 1;
    } else if (event.key === 'ArrowRight') {
      nextIndex = currentIndex + 1 >= buttons.length ? 0 : currentIndex + 1;
    } else {
      nextIndex = currentIndex - 1 < 0 ? buttons.length - 1 : currentIndex - 1;
    }

    buttons[nextIndex].focus();
    activateTab(tabsRoot, buttons[nextIndex]);
  }

  function parseSection(section) {
    var introTitle = getDatasetValue(section, 'c2bLegacyIntroTitle', DEFAULT_INTRO_TITLE);
    var skippedTitles = splitSkippedTitles(getDatasetValue(section, 'c2bLegacySkipTitles', DEFAULT_SKIPPED_TITLES));
    var source = section.querySelector(DESCRIPTION_CONTENT_SELECTOR);
    var result = {
      tabs: [],
      status: 'no-tabs-found'
    };

    if (!source) {
      result.status = 'no-source';
      setStatus(section, result.status);
      return result;
    }

    result.tabs = collectFromStationTabs(source, skippedTitles);

    if (result.tabs.length === 0) {
      result.tabs = collectFromRawHeadings(source, skippedTitles, introTitle);
    }

    if (result.tabs.length === 0) {
      result.status = 'no-tabs-found';
      setStatus(section, result.status);
      return result;
    }

    result.status = 'ready';
    return result;
  }

  function initSection(section, force) {
    var mode;
    var hideAfterSuccess;
    var displayMode;
    var manualTabsCount;
    var parsed;
    var tabs;
    var legacyTabsCount;
    var reviewsSource;
    var skippedTitles;
    var existingTabsRoot;

    if (!section) {
      return 'missing-section';
    }

    skippedTitles = splitSkippedTitles(getDatasetValue(section, 'c2bLegacySkipTitles', DEFAULT_SKIPPED_TITLES));

    if (section.hasAttribute(INIT_ATTRIBUTE) && !force) {
      existingTabsRoot = findGeneratedTabsRootForSection(section);

      if (generatedRootHasDescriptionTabs(existingTabsRoot, skippedTitles)) {
        return attachNativeReviewsTab(section) === 'pending' ? 'pending-reviews' : 'already-initialized';
      }

      removeExistingGenerated(section);
      section.removeAttribute(INIT_ATTRIBUTE);
      restoreDescriptionSection(section);
      setStatus(section, 'reset-invalid-generated-tabs');
    }

    mode = getDatasetValue(section, 'c2bLegacyTabsMode', 'off');

    if (mode === 'off') {
      removeExistingGenerated(section);
      restoreDescriptionSection(section);
      setStatus(section, 'mode-off');
      return 'mode-off';
    }

    manualTabsCount = parseInt(getDatasetValue(section, 'c2bManualTabsCount', '0'), 10) || 0;

    if (mode === 'if_no_manual_tabs' && manualTabsCount > 0) {
      removeExistingGenerated(section);
      restoreDescriptionSection(section);
      setStatus(section, 'manual-tabs-present');
      return 'manual-tabs-present';
    }

    parsed = parseSection(section);
    tabs = parsed.tabs.slice();
    legacyTabsCount = tabs.length;

    if (legacyTabsCount === 0) {
      removeExistingGenerated(section);
      section.removeAttribute(INIT_ATTRIBUTE);
      restoreDescriptionSection(section);
      return parsed.status;
    }

    reviewsSource = findNativeReviewsSource();

    if (reviewsSource && !titleExists(tabs, DEFAULT_REVIEWS_TITLE)) {
      tabs.push({
        title: DEFAULT_REVIEWS_TITLE,
        html: '',
        node: reviewsSource
      });
    }

    hideAfterSuccess = getDatasetValue(section, 'c2bLegacyHideAfterSuccess', 'false') === 'true';
    displayMode = getDatasetValue(section, 'c2bLegacyTabsDisplayMode', 'desktop_tabs_mobile_accordion');

    if (reviewsSource) {
      displayMode = 'tabs';
    }

    buildTabs(section, tabs, displayMode);
    section.setAttribute(INIT_ATTRIBUTE, 'true');
    setStatus(section, 'generated');

    if (hideAfterSuccess && legacyTabsCount > 0) {
      section.classList.add('is-hidden-by-c2b-legacy-tabs');
      section.setAttribute('aria-hidden', 'true');
    } else {
      restoreDescriptionSection(section);
    }

    return 'generated';
  }

  function getSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (safeElementMatches(scope, DESCRIPTION_SECTION_SELECTOR)) {
      return [scope];
    }

    return Array.prototype.slice.call(scope.querySelectorAll(DESCRIPTION_SECTION_SELECTOR));
  }

  function initAll(root, force) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = getSections(scope);
    var summary = {
      hasSections: sections.length > 0,
      initializedAny: false,
      pendingLegacy: false,
      pendingReviews: false
    };

    sections.forEach(function (section) {
      var status = initSection(section, force);
      var reviewsStatus = attachNativeReviewsTab(section);

      if (reviewsStatus === 'pending' || status === 'pending-reviews') {
        summary.pendingReviews = true;
      }

      if (status === 'generated') {
        summary.initializedAny = true;
      }

      if (status === 'no-source' || status === 'no-tabs-found') {
        summary.pendingLegacy = true;
      }
    });

    return summary;
  }

  function shouldRetry(summary) {
    if (!summary || !summary.hasSections) {
      return true;
    }

    return Boolean(summary.pendingLegacy || summary.pendingReviews);
  }

  function clearRetryTimers() {
    retryTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });

    retryTimers = [];
  }

  function retryInit(root) {
    var attempts = 0;

    clearRetryTimers();

    function run() {
      var summary;
      var timer;

      attempts += 1;
      summary = initAll(root || document, false);

      if (attempts < MAX_RETRIES && shouldRetry(summary)) {
        timer = window.setTimeout(function () {
          var index = retryTimers.indexOf(timer);

          if (index !== -1) {
            retryTimers.splice(index, 1);
          }

          run();
        }, RETRY_DELAY);

        retryTimers.push(timer);
      }
    }

    run();
  }

  function stop() {
    if (observer) {
      observer.disconnect();
      observer = null;
      observerTarget = null;
    }

    if (observerTimer) {
      window.clearTimeout(observerTimer);
      observerTimer = null;
    }

    if (observerRaf) {
      window.cancelAnimationFrame(observerRaf);
      observerRaf = null;
    }

    clearRetryTimers();
  }

  function scheduleObservedInit(root) {
    if (observerRaf) {
      return;
    }

    observerRaf = window.requestAnimationFrame(function () {
      observerRaf = null;
      initAll(root || document, false);
    });
  }

  function nodeContainsRelevantMarkup(node) {
    var selectors = [DESCRIPTION_SECTION_SELECTOR, GENERATED_SELECTOR, LEGACY_STATION_SELECTOR, '.shopify-app-block[id*="judge_me_reviews_review_widget"]', '#judgeme_product_reviews', '.jdgm-widget'];
    var index;

    if (!node || node.nodeType !== 1) {
      return false;
    }

    for (index = 0; index < selectors.length; index += 1) {
      if (safeElementMatches(node, selectors[index]) || safeElementContainsSelector(node, selectors[index])) {
        return true;
      }
    }

    return false;
  }

  function mutationIsRelevant(mutation) {
    var addedNodes;
    var index;

    if (!mutation) {
      return false;
    }

    if (mutation.type === 'attributes') {
      return Boolean(safeElementMatches(mutation.target, DESCRIPTION_SECTION_SELECTOR));
    }

    addedNodes = Array.prototype.slice.call(mutation.addedNodes || []);

    for (index = 0; index < addedNodes.length; index += 1) {
      if (nodeContainsRelevantMarkup(addedNodes[index])) {
        return true;
      }
    }

    return false;
  }

  function getObserverTarget(root) {
    var section;
    var target;

    if (root && root.nodeType === 1) {
      if (safeElementMatches(root, DESCRIPTION_SECTION_SELECTOR)) {
        return root.closest('main') || root.closest('product-info') || root.parentElement || root;
      }

      return root;
    }

    section = getSections(document)[0];
    target = section ? section.closest('main') || section.closest('product-info') || section.parentElement : null;

    return target || document.querySelector('main') || document.body;
  }

  function observeLateContent(root) {
    var target = getObserverTarget(root);

    if (!target) {
      return;
    }

    if (typeof MutationObserver === 'undefined') {
      retryInit(root || document);
      return;
    }

    if (observer && observerTarget === target) {
      return;
    }

    if (observer) {
      observer.disconnect();
      observer = null;
      observerTarget = null;
    }

    observer = new MutationObserver(function (mutations) {
      if (mutations.some(mutationIsRelevant)) {
        scheduleObservedInit(root || document);
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'data-c2b-legacy-tabs-mode',
        'data-c2b-legacy-hide-after-success',
        'data-c2b-legacy-tabs-display-mode',
        'data-c2b-manual-tabs-count'
      ]
    });

    observerTarget = target;

    if (observerTimer) {
      window.clearTimeout(observerTimer);
    }

    observerTimer = window.setTimeout(function () {
      if (observer) {
        observer.disconnect();
        observer = null;
        observerTarget = null;
      }
    }, OBSERVER_TIMEOUT);
  }

  function boot(root, force) {
    var scope = root || document;
    var summary = initAll(scope, !!force);

    if (shouldRetry(summary)) {
      retryInit(scope);
    }

    observeLateContent(scope);
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  namespace.version = VERSION;
  namespace.boot = boot;
  namespace.stop = stop;
  namespace.initAll = initAll;

  ready(function () {
    boot(document, false);
  });

  window.addEventListener('load', function () {
    boot(document, false);
  });

  window.addEventListener('pageshow', function () {
    boot(document, false);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      boot(document, false);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target, true);
  });

  document.addEventListener('shopify:section:select', function (event) {
    boot(event.target, true);
  });
})();
